export default "__VITE_ASSET__BovjhHOh__"